<template>
  <div>
    <div class="col-12 mt-4">
      <section-title
        title="Evaluaciones administradas previamente"
        :has-line="true"
      />
    </div>

    <div class="col-12 ">
      <div class="header thead-property d-flex align-items-center p-3">
        <div class="col-3 pt-0">
          <span>Evaluacion</span>
        </div>
        <div class="col-3 pt-0">
          <span>Fecha</span>
        </div>
        <div class="col-3 pt-0">
          <span>Administrada Por:</span>
        </div>
      </div>
    </div>

    <!--SIN Evaluaciones-->
    <div v-if="previouslyAdministeredEvaluations.length == 0" class="col-12">
      <div class="mb-4 p-4 info-seguimiento">
        <div class="col-12 text-center">
          <button
            id="btnFA"
            class="btn bg-light-white w-75 pt-1"
            @click="goToAddEvaluation()"
          >
            <i class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document">
              Presione aquí para añadir evaluaciones administradas previamente
            </span>
          </button>
        </div>
      </div>
    </div>

    <!--Con evaluaciones-->
    <div v-if="previouslyAdministeredEvaluations.length > 0" class="col-12">
      <Accordion id="accordionPrevioslyEvaluations">
        <AccordionItem
          v-for="evaluation in previouslyAdministeredEvaluations"
          id="accordionItemEvaluation"
          :key="evaluation.id"
          :title="evaluation.name"
          :expanded="false"
        >
          <div slot="header-content">
            <div class="col-12 d-flex align-space-between">
              <div class="col-4 pt-0 mr-2">
                <span>{{ evaluation.date }}</span>
              </div>
              <div class="col-4 pt-0 pl-0 ">
                <span>{{ evaluation.administrator }}</span>
              </div>
            </div>
          </div>
          <div slot="action">
            <div class="dropdown">
              <button
                id="ddEvaluation"
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="ddEvaluationEdit"
              >
                <!--TODO DELETE EVALUATION-->
                <div
                  class="dropdown-item"
                  @click="deleteEvaluation(evaluation)"
                >
                  <em class="fa fa-times-circle text-red pr-1" />
                  <span>Eliminar Evaluación</span>
                </div>
                <a class="dropdown-item" href="#">
                  <i class="fa fa-file-alt text-green pr-1" />
                  Documentos de Evaluación
                </a>
                <a class="dropdown-item" href="#">
                  <i class="fa fa-file-download text-green pr-1" />
                  Documento Evaluación
                </a>
                <a class="dropdown-item" href="#">
                  <i class="fa fa-file-download text-green" />
                  Documento Minuta
                </a>
              </div>
            </div>
          </div>
          <div slot="content">
            <div class="col-12 row mt-3 ">
              <div class="col-md-12 pl-4 pr-0 mr-1 ml-4 pt-0 ">
                <span><b>Comentario:</b></span>
                <p class="text-justify">
                  Sed ut perspiciatis unde omnis iste natus error sit voluptatem
                  accusantium doloremque laudantium, totam rem aperiam, eaque
                  ipsa quae ab illo inventore veritatis et quasi architecto
                  beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem
                  quia voluptas sit aspernatur aut odit aut fugit.
                </p>
              </div>
            </div>
          </div>
        </AccordionItem>
      </Accordion>
      <div class="text-right">
        <action-button
          variant="success m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-file-plus"
          @click="isCreatingTrackingItems = !isCreatingTrackingItems"
        >
          Añadir
        </action-button>
      </div>
    </div>

    <div class="col-12 ">
      <section-title title="Servicios de Otras Agencias" :has-line="true" />
    </div>
    <div class="col-12 ">
      <div class="header thead-property d-flex align-items-center p-3">
        <div class="col-3 pt-0">
          <span>Agencia</span>
        </div>
        <div class="col-3 pt-0">
          <span>Número</span>
        </div>
        <div class="col-3 pt-0">
          <span>Servicio(s)</span>
        </div>
      </div>
    </div>

    <div
      v-if="otherAgencyServices.length == 0 && !isCreatingAgenciItems"
      class="col-12"
    >
      <div class="mb-4 p-4 info-seguimiento">
        <div class="col-12 text-center">
          <button
            id="btnFA"
            class="btn bg-light-white w-75 pt-1"
            @click="isCreatingAgenciItems = !isCreatingAgenciItems"
          >
            <i class="fas fa-file-plus pr-4 text-green" />
            <span class="text-button-add-document">
              Presione aquí para anejar documento
            </span>
          </button>
        </div>
      </div>
    </div>

    <div v-if="isCreatingAgenciItems" class="col-12">
      <CustomCollapse id="agenciServicesAdd" class="mt-0 col-12">
        <CustomCollapseItem
          parent-id="agenciServicesAdd"
          title="Añadir Agencia"
          :selected="true"
          expanded
        >
          <div class="col-12 d-flex justify-content-left">
            <div class="col-4">
              <ValidationProvider
                v-slot="{ errors }"
                name="Agencia"
                :rules="`${isCreatingAgenciItems ? 'required' : ''}`"
              >
                <custom-drop-down
                  v-model="selectedAgency"
                  fieldname="name"
                  fieldkey="id"
                  :options="agencies"
                  placeholder="Seleccione"
                  label="Agencia:"
                  :error="errors[0]"
                  :custom-error-msg.sync="errors[0]"
                />
              </ValidationProvider>
            </div>

            <div class="col-4">
              <ValidationProvider
                v-slot="{ errors }"
                name="telefono"
                rules="required"
              >
                <CustomInput
                  v-model="agencyTelephone"
                  label="Número de Teléfono: "
                  required
                  :error="errors[0]"
                  :custom-error-msg.sync="errors[0]"
                />
              </ValidationProvider>
            </div>
            <div class="col-4">
              <ValidationProvider
                v-slot="{ errors }"
                class="w-100"
                name="services"
                rules="required"
              >
                <CustomTextArea
                  id="id"
                  v-model="service"
                  class="w-100"
                  label="Servicio(s)"
                  :maxlength="500"
                  placeholder="Escribir aqui"
                  required
                  :error="errors[0]"
                  :custom-error-msg.sync="errors[0]"
                />
              </ValidationProvider>
            </div>
          </div>

          <div class="row">
            <div class="col text-right">
              <ActionButton
                i="fas fa-times-circle"
                variant="outline-danger btn-cancel danger m-2"
              >
                Cancelar
              </ActionButton>
              <ActionButton variant="success m-2 pl-4 pr-4" type="submit">
                Añadir
              </ActionButton>
            </div>
          </div>
        </CustomCollapseItem>
      </CustomCollapse>
    </div>

    <div
      v-if="otherAgencyServices.length > 0 && !isCreatingAgenciItems"
      class="col-12"
    >
      <div
        v-for="agency in otherAgencyServices"
        :key="agency.id"
        class="d-flex align-content-center p-3"
      >
        <div class="col-3 ">
          <span>
            <b>{{ agency.name }}</b>
          </span>
        </div>
        <div class="col-3 ">
          <span>{{ agency.number }}</span>
        </div>
        <div class="col-3 ">
          <span>{{ agency.service }}</span>
        </div>
        <div class="col-3 text-right">
          <div slot="action">
            <div class="dropdown">
              <button
                id="ddEvaluation"
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu" aria-labelledby="ddEvaluationEdit">
                <a class="dropdown-item" href="#">
                  <i class="fa fa-pencil text-green pr-1" />
                  Editar
                </a>
                <a class="dropdown-item" href="#">
                  <i class="fas fa-times-circle text-red" />
                  Eliminar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-right">
        <action-button
          variant="success m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-file-plus"
          @click="isCreatingTrackingItems = !isCreatingTrackingItems"
        >
          Añadir
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from '@/components/common/page/SectionTitle.vue';
import { Accordion, AccordionItem } from '@/components/pei/shared/accordion';
import { ActionButton } from '@/components/common';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomInput from '@/components/common/CustomInput';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import Alert from '@/mixin/alert.mixin';
import store from '@/store/index'; //Se debe coordinar si los components tendran acceso al store o no.

export default {
  name: 'EvaluationServicesTab',
  mixins: [Alert],
  data() {
    return {
      evaluations: {},
      previouslyAdministeredEvaluations: [
        {
          id: 0,
          name: 'Evaluación Inicial - Low Vision',
          date: '07/mar/2018',
          administrator: 'Especialista por contrato',
          comment: 'Texto de comentario aparecerá aquí. (Read only)',
        },
      ],
      otherAgencyServices: [
        {
          id: 0,
          name: 'Agencia Seleccionada',
          number: '758302893',
          service: 'Servicios seleccionados',
        },
      ],
      isCreatingAgenciItems: false,
      categories: [],
      agencies: [],
      agencyTelephone: null,
      selectedAgency: null,
      service: null,
    };
  },

  components: {
    SectionTitle,
    Accordion,
    AccordionItem,
    ActionButton,
    CustomTextArea,
    CustomInput,
    CustomDropDown,
    CustomCollapse,
    CustomCollapseItem,
  },

  methods: {
    async GetPreviouslyAdministeredEvaluations() {
      let self = this;
      return await self
        .$ApiGet(
          '/api/atservice/GetRecentEvaluations?peiId=' +
            store.getters.SelectedPei
        )
        .then((res) => {
          this.evaluations = res.data;
        })
        .catch((errm) => {
          self.ShowToast(errm.message, '', 'error');
        });
    },
    goToAddEvaluation() {
      this.$router.push({ path: '/student/addEvaluation' });
    },

    goToEditEvaluation() {
      this.$router.push({ path: '/student/addEvaluation' });
    },

    deleteEvaluation() {
      this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar la evaluación? ',
        'Si',
        'No'
      ).then(function(response) {
        if (response) {
          //TODO: Eliminar evaluacion
        }
      });
    },
  },

  async mounted() {
    await this.GetPreviouslyAdministeredEvaluations();
  },
};
</script>

<style scoped>
.header {
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.info-seguimiento {
  background: #fafbfa 0% 0% no-repeat padding-box;
  opacity: 1;
}
</style>
